import React, { useContext, useEffect, useState } from "react";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { Box, Button, Paper, Snackbar, Stack, Tab, TableContainer, Tabs } from "@mui/material";
import BeneficiarioNomeIdAlinhadoDireita from "../../../Componentes_modulo/Beneficiario_nome_id_alinhado_direita";
import EficienciaAlimentarViewTecnico from "../../../Styles/layout/eficienciaAlimentarView";
import { TabelaBalancoGH1 } from "./balancoGH1";
import { IBalanco, IMesDois, IMesUm } from "../../../Interfaces/eficiencia_alimentar/cc_caderno_campo";
import { IGrupos_Homo_Eficiencia_Alimentar } from "../../../Interfaces/eficiencia_alimentar/plano_de_alimentacao";
import { TabelaMes } from "./tabelas_mes";
import { get, post } from "../../../Services/tokenConfig";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { func_print } from "../../../Func_genericas/func_print";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { cores, meses_ano } from "../../../Func_genericas/valores_estaticos";
import { CabecalhoForm } from "./cabecalho";
import { Alert } from "../../../Components/Alert/Alert";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },

    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(2, 3),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },

  })
);



export default function EF_CC_GH1() {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);

  const auth = useContext(AuthContext);

  const [lista_tabela_editavel, set_lista_tabela_editavel] = useState<IMesDois[]>([]);
  const [obj_tabela_editavel, set_obj_tabela_editavel] = useState<IMesDois>();
  const [obj_tabela_nao_editavel, set_obj_tabela_nao_editavel] = useState<IMesUm>();
  const [lista_tabela_nao_editavel, set_lista_tabela_nao_editavel] = useState<IMesUm[]>([]);
  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [mes_escolhido, set_mes_escolhido] = useState<string>('janeiro');
  const [create, setCreate] = useState(false);
  const [rows_balanco, set_rows_balanco] = useState<IBalanco>()

  const [especie_ou_lote_homegenio_selecionada, set_especie_ou_lote_homegenio_selecionada] = useState<IGrupos_Homo_Eficiencia_Alimentar>();


  async function get_info(idCabecalho: number | undefined) {
    try {
      let aux_lista!: IMesDois[]
      if (idCabecalho !== undefined && idCabecalho !== 0) {
        let res = await get(auth.token.cookie_token, `/get_mes_tab_um_id_tipo_alimento/${idCabecalho}`);

        if (res.status === 200) {
          if (res.data.result.length === 0) {
            set_lista_tabela_nao_editavel([])
            set_lista_tabela_editavel([])
            set_obj_tabela_nao_editavel(undefined);

            setCreate(true)
          } else {
            set_lista_tabela_nao_editavel(res.data.result);
            if (res.data.result.length !== 0) {
              res.data.result.forEach((el: IMesUm) => {
                if (el.Registo_Efeciencia_CC_GH_mes_tabela_dois_.length !== 0) {
                  if (aux_lista === undefined) {
                    aux_lista = el.Registo_Efeciencia_CC_GH_mes_tabela_dois_
                  } else {
                    aux_lista.push(el.Registo_Efeciencia_CC_GH_mes_tabela_dois_[0])
                  }
                }
              })
              set_lista_tabela_editavel(aux_lista);

              set_mes_escolhido(res.data.result[0].mes)
              set_obj_tabela_nao_editavel(res.data.result[0]);
            }
            if (aux_lista !== undefined) {
              let aux_obj_tabela_editavel = aux_lista.find((el: any) => el.id_mes_tab_um === res.data.result[0].id_mes_tab_um)
              if (aux_obj_tabela_editavel === undefined) {
                setCreate(true)
              } else {
                set_obj_tabela_editavel(aux_obj_tabela_editavel)
              }
            } else {
              setCreate(true)
            }
          }

        }
        setIsLoading(false);
      };
    } catch (error) {
      func_print("getTabela", error, true);
      setIsLoading(false);
    }
  };

  const handle_criar_tabela_nao_editavel = async () => {

    try {

      let res = await post(auth.token.cookie_token, "new__balanco_mes_tab_um", {
        payload: {
          id_mes_tab_um: 0,
          mes: mes_escolhido,
          bovinos_M_menor_seis_Pastagem: 0,
          bovinos_F_menor_seis_Pastagem: 0,
          bovinos_M_seis_um_Pastagem: 0,
          bovinos_F_seis_um_Pastagem: 0,
          bovinos_M_um_dois_Pastagem: 0,
          bovinos_F_um_dois_Pastagem: 0,
          bovinos_M_maior_dois_Pastagem: 0,
          bovinos_F_maior_dois_Pastagem: 0,
          bovinos_M_menor_seis_Silagem: 0,
          bovinos_F_menor_seis_Silagem: 0,
          bovinos_M_seis_um_Silagem: 0,
          bovinos_F_seis_um_Silagem: 0,
          bovinos_M_um_dois_Silagem: 0,
          bovinos_F_um_dois_Silagem: 0,
          bovinos_M_maior_dois_Silagem: 0,
          bovinos_F_maior_dois_Silagem: 0,
          bovinos_M_menor_seis_outra_ferragem: 0,
          bovinos_F_menor_seis_outra_ferragem: 0,
          bovinos_M_seis_um_outra_ferragem: 0,
          bovinos_F_seis_um_outra_ferragem: 0,
          bovinos_M_um_dois_outra_ferragem: 0,
          bovinos_F_um_dois_outra_ferragem: 0,
          bovinos_M_maior_dois_outra_ferragem: 0,
          bovinos_F_maior_dois_outra_ferragem: 0,
          bovinos_M_menor_seis_Composto: 0,
          bovinos_F_menor_seis_Composto: 0,
          bovinos_M_seis_um_Composto: 0,
          bovinos_F_seis_um_Composto: 0,
          bovinos_M_um_dois_Composto: 0,
          bovinos_F_um_dois_Composto: 0,
          bovinos_M_maior_dois_Composto: 0,
          bovinos_F_maior_dois_Composto: 0,
          bovinos_M_menor_seis_Anexo: '',
          bovinos_F_menor_seis_Anexo:  '',
          bovinos_M_seis_um_Anexo: '',
          bovinos_F_seis_um_Anexo: '',
          bovinos_M_um_dois_Anexo: '',
          bovinos_F_um_dois_Anexo:  '',
          bovinos_M_maior_dois_Anexo:  '',
          bovinos_F_maior_dois_Anexo:  '',
          id_grupo: especie_ou_lote_homegenio_selecionada?.id_grupo,
          last_update: new Date().toISOString(),
          create_date: new Date().toISOString(),
          uuid: "",
        }
      });
      if (res.status === 200) {
        setMessage("Gravado com sucesso!");

        set_lista_tabela_nao_editavel((prevRows) => {
          return [...prevRows, (res.data.result[0])]
        });
        set_rows_balanco(res.data.result[1][0])
        set_obj_tabela_nao_editavel(res.data.result[0])
        setCreate(true)
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleSaveTabelaMes", error, true);
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      await get_info(especie_ou_lote_homegenio_selecionada?.id_grupo);
    })();
  }, [especie_ou_lote_homegenio_selecionada?.id_grupo]);


  return (
    <div className={classes.root}>
      <EficienciaAlimentarViewTecnico title="CC Grupos Homogéneos" />
      <main className={classes.contents}>
        <div className={classes.toolbars} />

        <Snackbar
          open={openSnackSuccess}
          autoHideDuration={2000}
          onClose={() => setOpenSnackSuccess(false)}
        >
          <Alert
            onClose={() => setOpenSnackSuccess(false)}
            severity="success"
            sx={{ width: "100%" }}
          >
            {message}
          </Alert>
        </Snackbar>
        <Snackbar
          open={openSnackError}
          autoHideDuration={2000}
          onClose={() => setOpenSnackError(false)}
        >
          <Alert
            onClose={() => setOpenSnackError(false)}
            severity="error"
            sx={{ width: "100%" }}
          >
            {message}
          </Alert>
        </Snackbar>
        <Box width="80%" margin="auto">
          <BeneficiarioNomeIdAlinhadoDireita />
        </Box>

        <CabecalhoForm
          especie_ou_lote_homegenio_selecionada={especie_ou_lote_homegenio_selecionada}
          set_especie_ou_lote_homegenio_selecionada={set_especie_ou_lote_homegenio_selecionada}
          setIsLoading={setIsLoading}
        ></CabecalhoForm>
        {isLoading ?
          <LoadingVulpes />
          :
          especie_ou_lote_homegenio_selecionada === undefined ? <></> :
            <>
              <TabelaBalancoGH1
                idCabecalho={especie_ou_lote_homegenio_selecionada?.id_grupo}
                set_rows_balanco={set_rows_balanco}
                rows_balanco={rows_balanco}
              />

              <TableContainer
                component={Paper}
                variant="outlined"
                sx={{
                  height: "auto",
                  width: "auto",
                  margin: 2,
                  padding: 2,
                }}
              >
                <Tabs
                  value={mes_escolhido}
                  onChange={(e, v) => {
                    set_mes_escolhido(v)
                    if (lista_tabela_nao_editavel.length !== 0) {
                      // func_print('lista_tabela_nao_editavel', lista_tabela_nao_editavel)
                      func_print('lista_tabela_editavel', lista_tabela_editavel)
                      let aux = lista_tabela_nao_editavel.find((el) => el.mes === v)
                      set_obj_tabela_nao_editavel(aux)
                      if (lista_tabela_editavel !== undefined && lista_tabela_editavel.length !== 0 && aux !== undefined) {
                        let aux1 = lista_tabela_editavel.find((el) => el.id_mes_tab_um === aux?.id_mes_tab_um)
                        if (aux1 !== undefined) {
                          set_obj_tabela_editavel(aux1)
                          setCreate(false)

                        } else {
                          set_obj_tabela_editavel(undefined)
                          setCreate(true)
                        }
                      } else {
                        set_obj_tabela_editavel(undefined)
                      }
                    } else {
                      set_obj_tabela_nao_editavel(undefined)
                      set_obj_tabela_editavel(undefined)

                    }

                  }}
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="scrollable auto tabs example"
                >
                  {meses_ano.map((label, index) => (
                    <Tab key={index} value={label} label={label} />
                  ))}
                </Tabs>

                {
                  obj_tabela_nao_editavel === undefined ?
                    <div style={{
                      display: "flex",
                      alignSelf: "center",
                      justifySelf: 'center',
                      margin: 30,
                    }}>

                      <Button
                        size="large"
                        sx={{
                          backgroundColor: cores.cor1,
                          color: "#ffffff",
                          width: 300,

                          "&:hover": {
                            backgroundColor: "transparent",
                            color: "#7e2706",
                          },
                          fontFamily: "candara",
                        }}
                        onClick={() => { handle_criar_tabela_nao_editavel() }}
                      >
                        Novo registo
                      </Button>
                    </div>
                    :
                    <Stack direction="row">
                      <TabelaMes
                        lista_tabela_editavel={lista_tabela_editavel}
                        set_lista_tabela_editavel={set_lista_tabela_editavel}
                        obj_tabela_nao_editavel={obj_tabela_nao_editavel}
                        set_obj_tabela_nao_editavel={set_obj_tabela_nao_editavel}
                        obj_tabela_editavel={obj_tabela_editavel}
                        set_obj_tabela_editavel={set_obj_tabela_editavel}
                        setCreate={setCreate}
                        create={create}
                        set_rows_balanco={set_rows_balanco}
                        mes_escolhido={mes_escolhido}
                        lista_tabela_nao_editavel={lista_tabela_nao_editavel}
                        set_lista_tabela_nao_editavel={set_lista_tabela_nao_editavel}
                        idCabecalho={especie_ou_lote_homegenio_selecionada?.id_grupo}

                      />
                    </Stack>

                }


              </TableContainer>

            </>
        }
      </main>
    </div>
  );
}
